export default {
  name: "investigador",
  component: () => import("@/modules/investigator/layouts/InvestigatorLayout.vue"),
  children: [
    {
      path: "/investigador",
      name: "investigator",
      component: () => import("@/modules/investigator/views/ProjectsInvestigatorView.vue"),
    },
    {
      path: "/investigador/proyectos",
      name: "projectsInvestigator",
      component: () => import("@/modules/investigator/views/ProjectsInvestigatorView.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },    
    {
      path: "/investigador/perfil",
      name: "perfilInvestigador",
      component: () => import("@/modules/investigator/views/PerfilView.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },

    {
      path: "/investigador/constancias",
      name: "constanciasInvestigador",
      component: () => import("@/modules/investigator/views/ConstanciasInv.vue"),
      beforeEnter: (to, from, next) =>{
        if(!localStorage.getItem('session_id')) next('/');
        else next();
      }
    },
  ],
}
